import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { Router, provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { KeycloakAngularModule, KeycloakBearerInterceptor, KeycloakService } from 'keycloak-angular';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { environment } from 'src/environments/environment';
import { provideToastr } from 'ngx-toastr';

function initializeKeycloak(keycloak: KeycloakService, router: Router) {
  return () =>
    keycloak
      .init({
        config: {
          url: environment.keycloak.url,
          realm: environment.keycloak.realm,
          clientId: environment.keycloak.clientId
        },
        initOptions: {
          onLoad: 'check-sso',
          silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
          checkLoginIframe: true,
          checkLoginIframeInterval: 5,
          enableLogging: true,
          refreshToken: 'true'
        },
        bearerExcludedUrls: ['/login', '/acces-interdit', '/portail']
      })
      .then((auth) => {
        if (auth) {
          const isLogin = sessionStorage.getItem('isLoginAction');

          if (!isLogin) {
            sessionStorage.setItem('isLoginAction', 'true');
            router.navigate(['/pama']);
          }
        }
      })
      .catch((error) => {
        console.error('Keycloak initialization failed, redirecting to login.', error);
        return keycloak.login({ redirectUri: window.location.href });
      });
}
export const appConfig: ApplicationConfig = {
  providers: [
    KeycloakService,
    KeycloakAngularModule,
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 2500, horizontalPosition: 'right', verticalPosition: 'top' } },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    provideHttpClient(withInterceptorsFromDi()),
    provideAppInitializer(() => {
        const initializerFn = (initializeKeycloak)(inject(KeycloakService), inject(Router));
        return initializerFn();
      }),
    { provide: HTTP_INTERCEPTORS, useClass: KeycloakBearerInterceptor, multi: true },
    provideRouter(routes),
    importProvidersFrom([BrowserAnimationsModule]),
    provideAnimations(), // required animations providers
    provideToastr() // Toastr providers
  ]
};
